import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PriceFormattingService {
  /**
   * Formatea el precio entero con separadores de miles
   */
  formatIntegerPrice(price: number): string {
    const intPrice = Number(price.toString().split('.')[0]);
    return intPrice.toLocaleString('es-CO').replace(/\./g, ',');
  }

  /**
   * Obtiene solo la parte decimal del precio
   */
  getDecimalPrice(price: number): string {
    const decimal = price.toString().split('.')[1] ?? '00';
    return decimal.length === 1 ? `0${decimal}` : decimal;
  }

  /**
   * Limpia el precio eliminando decimales innecesarios
   */
  cleanPrice(price: number): string {
    const priceStr = price.toString();
    const parts = priceStr.split('.');

    if (parts.length === 1) {
      return priceStr;
    }

    const integerPart = parts[0];
    const decimalPart = parts[1];

    // Si los decimales son solo ceros, devolver solo la parte entera
    if (decimalPart === '0000' || decimalPart === '00') {
      return integerPart;
    }

    // Si los decimales terminan en ceros, limpiarlos
    const cleanDecimal = decimalPart.replace(/0+$/, '');

    // Si después de limpiar no quedan decimales, devolver solo la parte entera
    if (cleanDecimal === '') {
      return integerPart;
    }

    return `${integerPart}.${cleanDecimal}`;
  }
}
